import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-our-clients',
  templateUrl: './our-clients.component.html',
  styleUrls: ['./our-clients.component.scss']
})
export class OurClientsComponent implements OnInit {
  @Input() pricingLink!:string;
  titleSectionProp: any = {
    class: 'text-left iq-title-box-2  iq-title-white',
    title: 'HAPPY_CLIENTS',
    titleIcon: '',
    description: 'HAPPY_CLIENTS_DESCRIPTION'
  };
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute
  ) { }

  ngOnInit(): void {
    
  }

}
